import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Routes, Route } from "react-router-dom";
import "./golfstatus-organizations.scss";
import { connect, useSelector } from "react-redux";
import {
  GSAppLayout,
  GSAppNavigationHeader,
  GSCircleImage,
  GSPageBanner,
} from "golfstatus_react_components";
import { getCurrentUser } from "../app/gs-session";
import logo from "../images/GSLogo.svg";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import {
  clearNotifications,
  selectCurrentUser,
  selectUser,
} from "../reducers/appSlice";
import OrganizationList from "./organization-list";
import OrganizationRouter from "./organization-router";
import OrganizationOverview from "./overview/organization-overview";
import UsersPermissions from "./users-permissions/users-permissions";
import AddUser from "./users-permissions/add-edit-user";
import DeleteUser from "./users-permissions/delete-user";
import OrganizationDiscounts from "./discounts/organization-discounts";
import OrganizationDiscountAddEdit from "./discounts/organization-discount-add-edit";
import OrganizationDiscountDelete from "./discounts/organization-discount-delete";
import PermissionTypeInfo from "./users-permissions/permissions-type-info";
import { clearNotifications as clearUserNotifications } from "../reducers/userSlice";
import OrganizationAccessLists from "./access-lists/organization-access-lists";
import OrganizationAccessListCreateEdit from "./access-lists/organization-access-list-create-edit";
import OrganizationAccessListDelete from "./access-lists/organization-access-list-delete";
import OrganizationAccessListOverview from "./access-lists/organization-access-list-overview";
import OrganizationAccessCodeCreateEdit from "./access-lists/organization-access-code-create-edit";
import OrganizationAccessCodeDelete from "./access-lists/organization-access-code-delete";
import OrganizationAccessListDownload from "./access-lists/organization-access-list-upload";
import OrganizationSettings from "./settings-preferences/organization-settings";
import OrganizationEdit from "./overview/organization-edit";
import OrganizationSettingsEventsList from "./settings-preferences/organization-settings-events-list";
import OrganizationSettingsPrivacy from "./settings-preferences/organization-settings-privacy";
import OrganizationSettingsHero from "./settings-preferences/organization-settings-hero";
import OrganizationSettingsLinks from "./settings-preferences/organization-settings-links";
import OrganizationSettingsPayments from "./settings-preferences/organization-settings-payments";
import RemoveStripeAccount from "./settings-preferences/remove-stripe-account";
import RemoveBankAccount from "./settings-preferences/remove-bank-account";
import AddBankAccount from "./settings-preferences/add-bank-account";
import VerifyBankAccount from "./settings-preferences/verify-bank-account";
import { useNotificationBanner } from "../hooks/notificationHooks";
import OrganizationLogoEditImage from "./overview/organization-logo-edit-image";
import OrganizationBannerImageEditImage from "./settings-preferences/organization-banner-image-edit-image";
import StripeAccountConnected from "./settings-preferences/stripe-account-connected";

const GolfstatusOrganizations = (props) => {
  const { title, nav, appNotifications, dispatch } = props;
  const routeNavigate = useNavigate();
  const { pathname } = useLocation();
  const [hideEnvironment, setHideEnvironment] = useState(false);
  const currentUser = useSelector(selectCurrentUser);
  const cookieUser = getCurrentUser();

  useEffect(() => {
    if (cookieUser?.uid && cookieUser?.uid !== currentUser?.id) {
      dispatch(selectUser(cookieUser?.uid));
    }
  }, [cookieUser?.uid, currentUser?.id, dispatch]);

  const getTitle = () => {
    return (
      <GSAppNavigationHeader logo={logo} title={title}></GSAppNavigationHeader>
    );
  };
  const getActiveRoute = () => {
    return pathname;
  };
  const getFooter = () => {
    const user = getCurrentUser();
    const defaultAvatar = "https://api.golfstatus.dev/images/user_round.png";
    return [
      {
        id: 0,
        label: (
          <GSCircleImage
            url={user.avatar ? user.avatar : defaultAvatar}
            size="large"
          ></GSCircleImage>
        ),
        isSelectable: true,
        url: `${process.env.REACT_APP_GOLFSTATUS_PROFILE_URL}`,
        isExternal: true,
      },
    ];
  };
  const navigate = (item) => {
    if (item.isExternal) {
      window.location.href = item.url;
    } else {
      routeNavigate(item.url);
    }
  };
  const getEnvironmentActions = () => {
    return [
      {
        actionIcon: faTimesCircle,
        type: "navigation",
        size: "secondary",
        actionClick: hideNavEnvironment,
      },
    ];
  };

  const getShowEnvironment = () => {
    if (hideEnvironment) {
      return false;
    }
    return (
      process.env.REACT_APP_ENV !== "production" &&
      process.env.REACT_APP_ENV !== "demo"
    );
  };

  const hideNavEnvironment = () => {
    setHideEnvironment(true);
  };

  const getNavigationActions = () => {
    return [
      {
        title: "Clear",
        size: "secondary",
        onClick: timeoutAction,
      },
    ];
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
    dispatch(clearUserNotifications());
  };

  const getListPage = (title) => {
    return <OrganizationList />;
  };

  const headerClicked = () => {
    routeNavigate("/");
  };

  const getRouter = () => {
    return (
      <Routes>
        <Route key={10} path={"/"} element={getListPage("My Organizations")} />
        <Route
          path={"stripe-account-connected"}
          element={<StripeAccountConnected />}
        />
        <Route key={10} path={":id"} element={<OrganizationRouter />}>
          <Route index element={<OrganizationOverview />} />
          <Route path={"/:id/permissions"} element={<UsersPermissions />}>
            <Route path={"add"} element={<AddUser />} />
            <Route path={"type-info"} element={<PermissionTypeInfo />} />
            <Route path={":memberID/edit-member"} element={<AddUser />} />
            <Route path={":memberID/delete-member"} element={<DeleteUser />} />
          </Route>
          <Route path={"/:id/discounts"} element={<OrganizationDiscounts />}>
            <Route path={"add"} element={<OrganizationDiscountAddEdit />} />
            <Route
              path={":discountID/edit"}
              element={<OrganizationDiscountAddEdit />}
            />
            <Route
              path={":discountID/delete"}
              element={<OrganizationDiscountDelete />}
            />
          </Route>
          <Route path={"/:id/access"} element={<OrganizationAccessLists />}>
            <Route
              path={"add"}
              element={<OrganizationAccessListCreateEdit />}
            />
            <Route
              path={":accessListID/edit"}
              element={<OrganizationAccessListCreateEdit />}
            />
            <Route
              path={":accessListID/delete"}
              element={<OrganizationAccessListDelete />}
            />
            <Route
              path={":accessListID"}
              element={<OrganizationAccessListOverview />}
            />
            <Route
              path={":accessListID/code/add"}
              element={<OrganizationAccessCodeCreateEdit />}
            />
            <Route
              path={":accessListID/code/:accessCodeID"}
              element={<OrganizationAccessCodeCreateEdit />}
            />
            <Route
              path={":accessListID/code/:accessCodeID/delete"}
              element={<OrganizationAccessCodeDelete />}
            />
            <Route
              path={":accessListID/upload"}
              element={<OrganizationAccessListDownload />}
            />
          </Route>
          <Route path={"/:id/settings"} element={<OrganizationSettings />}>
            <Route path={"details"} element={<OrganizationEdit />} />
            <Route path={"details/organization-logo/edit/image"} element={<OrganizationLogoEditImage />} />
            <Route
              path={"events"}
              element={<OrganizationSettingsEventsList />}
            />
            <Route
              path={"events/hero"}
              element={<OrganizationSettingsHero />}
            />
            <Route
              path={"events/hero/edit/image"}
              element={<OrganizationBannerImageEditImage />}
            />
            <Route
              path={"events/links"}
              element={<OrganizationSettingsLinks />}
            />
            <Route
              path={"payments"}
              element={<OrganizationSettingsPayments />}
            />
            <Route
              path={"payments/disconnect-stripe-account"}
              element={<RemoveStripeAccount />}
            />
            <Route
              path={"payments/remove-bank-account"}
              element={<RemoveBankAccount />}
            />
            <Route
              path={"payments/add-bank-account"}
              element={<AddBankAccount />}
            />
            <Route
              path={"payments/verify-bank-account"}
              element={<VerifyBankAccount />}
            />
            <Route path={"privacy"} element={<OrganizationSettingsPrivacy />} />
          </Route>
          <Route path={"/:id/edit"} element={<OrganizationOverview />} />
        </Route>
      </Routes>
    );
  };

  const getNav = () => {
    return {
      navItems: nav,
      title: getTitle(),
      footerItems: getFooter(),
      activeRoute: getActiveRoute(),
      showEnv: getShowEnvironment(),
      environmentActions: getEnvironmentActions(),
      environment: `${process.env.REACT_APP_ENV} environment`,
      environmentDescription: process.env.REACT_APP_GOLFSTATUS_BASE_API_URL,
    };
  };

  const [bannerNotifications] = useNotificationBanner({
    notifications: appNotifications,
    navigationActions: getNavigationActions(),
    timeoutAction,
  });

  return (
    <golfstatus-organizations>
      <GSAppLayout
        navigationItemSelected={navigate}
        nav={getNav()}
        notification={
          appNotifications?.length > 0 ? (
            <GSPageBanner {...bannerNotifications} />
          ) : (
            false
          )
        }
        routes={getRouter()}
        headerClicked={headerClicked}
      />
    </golfstatus-organizations>
  );
};

const mapStateToProps = (state) => ({
  title: state.app.title,
  nav: state.app.nav,
  appNotifications: state.app.notifications,
  usersNotifications: state.users.slideOutNotifications,
});

export default connect(mapStateToProps)(GolfstatusOrganizations);
